export interface Project {
  id: string;
  name: string;
  urlLink: string | null;
  github: string;
  technologies: string[];
  details: string;
  images: string[];
  featured?: boolean;
}

export const projects: Project[] = [
  {
    id: 'gigboard',
    name: 'Gigboard',
    urlLink: null,
    github: 'https://github.com/BEllis0/gigboard-client',
    technologies: ['React Native', 'Expo', 'TypeScript', 'Firebase', 'Firestore', 'React Navigation', 'Formik'],
    details: 'A mobile platform for musicians to discover, connect, and collaborate on local gigs. Features location-based discovery, real-time messaging, auth via Firebase, image uploads, and event scheduling. Built with Expo and React Native for cross-platform iOS/Android support.',
    images: [],
    featured: true,
  },
  {
    id: 'trading-notifications',
    name: 'Trading Notifications',
    urlLink: null,
    github: 'https://github.com/BEllis0/trading-notifications',
    technologies: ['TypeScript', 'AWS Lambda', 'DynamoDB', 'SNS', 'SAM', 'Node.js', 'EventBridge'],
    details: 'A serverless AWS application that syncs FDA PDUFA (Prescription Drug User Fee Act) calendar data on a cron schedule, processes and stores events in DynamoDB, and sends email notifications via SNS for upcoming drug approval decision dates. Also tracks trading halts with real-time RSS ingestion.',
    images: [],
    // featured: true,
  },
  {
    id: 'logger',
    name: 'Logger',
    urlLink: 'https://www.npmjs.com/package/log-inspector',
    github: 'https://github.com/BEllis0/_logger',
    technologies: ['JavaScript', 'Node.js'],
    details: 'A simple logging tool for debugging in the browser. Enabled in the console to display your _logger messages and ensure they are not seen by users. For those familiar with Adobe Launch, the functionality is similar to _satellite.logger.',
    images: [
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/logger1.jpg',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/logger3.jpg',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/logger2.jpg',
    ],
  },
  {
    id: 'website-performance-ext',
    name: 'Website Performance Chrome Extension',
    urlLink: null,
    github: 'https://github.com/BEllis0/website-performance-extension',
    technologies: ['JavaScript', 'HTML', 'CSS'],
    details: 'Chrome extension and backend service that scans the page you\'re on and generates a page performance report in xlsx. Developed backend service to gather, clean, cache and build Excel reporting with page performance metrics from the Google Lighthouse API.',
    images: [
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/website_ext.jpg',
    ],
  },
  {
    id: 'spotify-dashboard',
    name: 'Spotify Dashboard',
    urlLink: null,
    github: 'https://github.com/spotify-dashboard/spotify-client',
    technologies: ['JavaScript', 'React', 'Redux', 'Sass', 'Node.js', 'Express', 'Heroku', 'Jest'],
    details: 'A dashboarding and library cleaning tool created with the Spotify API that allows a user to view activity metrics, gain insight into their listening habits, and clean out old and unlistened songs from their libraries. Features include realtime viewing of currently playing song, viewing playlists and account information.',
    images: [
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-playlistall.jpg',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-playlist-songs.jpg',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-account.jpg',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-tool_time.png',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-tool_repeat.png',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-tool_audio.png',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/spotify-tool_genres.png',
    ],
    featured: true,
  },
  {
    id: 'watchlists',
    name: 'Watchlists.io | Stock App',
    urlLink: 'http://watchlists.io/',
    github: 'https://github.com/BEllis0/Stock-App',
    technologies: ['JavaScript', 'React', 'CSS', 'Node.js', 'Express', 'MongoDB', 'Mongoose', 'Heroku'],
    details: 'A full stack stock app with real time/historical data charting, stock news, IPO & earnings calendars, and account & watchlist creation. Features interactive stock charting, web sockets for real time pricing, user authentication with password hashing, HTTP access tokens, and Google Recaptcha.',
    images: [
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/watchlists-stock-app_home.png',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/watchlists-stock-app_calendar.png',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/watchlists-stock-app_search.png',
      'https://d204t2bnuk7ee7.cloudfront.net/assets/images/watchlists-stock-app_charts.png',
    ],
    featured: true,
  },
];
